import { NavLink } from "react-router-dom";
import { Home, Compass, CalendarDays, Radio, User } from "lucide-react";

const items = [
  { to: "/", label: "Accueil", icon: Home },
  { to: "/explorer", label: "Explorer", icon: Compass },
  { to: "/evenements", label: "Events", icon: CalendarDays },
  { to: "/live", label: "LIVE", icon: Radio, live: true },
  { to: "/favoris", label: "Profil", icon: User },
];

export default function MobileNav() {
  return (
    <nav className="lg:hidden fixed bottom-0 inset-x-0 z-50 glass border-t border-white/10" data-testid="mobile-bottom-nav">
      <div className="grid grid-cols-5">
        {items.map((it) => {
          const Icon = it.icon;
          return (
            <NavLink key={it.to} to={it.to} data-testid={`mnav-${it.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex flex-col items-center gap-0.5 py-2.5 text-[11px] font-semibold ${isActive ? "text-[#FF5A00]" : "text-slate-400"}`}>
              <span className="relative">
                <Icon className="w-5 h-5" />
                {it.live && <span className="absolute -top-0.5 -right-1 w-1.5 h-1.5 rounded-full bg-[#FF5A00] live-dot" />}
              </span>
              {it.label}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
